import { useState, useEffect } from "react";
import "../../pages/SalesMasterPages/AddLead/AddLead.css";
import React from "react";
import axios from "axios";

const AssignTask = () => {
  const [errors, setErrors] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;
  const [assignToResponse, setAssignToResponse] = useState([]);
  const [departmentDetailResponse, setDepartmentResponse] = useState([]);

  const [formData, setFormData] = useState({
    task_start_date: "",
    due_date: "",
    AssignedTo: "",
    task_category: "",
    task_title: "",
    task_description: "",
    task_priority: "",
    task_source: "",
    department: "",
    remark: "",
  });

  function getEmployeeByDepartment() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}adminget/GETEmployeeByDepartment?department_id=`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setAssignToResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (errors[name]) {
      setErrors({ ...errors, [name]: null });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}userpost/InsertTaskAssignedByMe`,
        formData, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      alert("Data successfully saved");
      // Optionally, reset the form
      setFormData({
        task_start_date: "",
        due_date: "",
        AssignedTo: "",
        task_category: "",
        task_title: "",
        task_description: "",
        task_priority: "",
        task_source: "",
        department: "",
        remark: "",
      });
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  useEffect(() => {
    getEmployeeByDepartment();

    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GETDepartment?department=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setDepartmentResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  return (
    <div
      className="container-fluid container-AddLead"
      style={{ backgroundColor: "white" }}
    >
      <table style={{ width: "100%" }}>
        <tbody>
          <tr className="space">
            <td colSpan={3}></td>
          </tr>
          <tr className="tableHeading">
            <td>Assigned To</td>
            <td>Start Date</td>
            <td>Due Date</td>
          </tr>
          <tr>
            <td>
              <select
                className="form-control"
                name="AssignedTo"
                value={formData.AssignedTo}
                onChange={handleChange}
              >
                <option value="0">Select an option</option>
                {assignToResponse.map((item) => (
                  <option
                    value={item.customer_id}
                    className={item.is_available ? "green" : "black"}
                  >
                    {item.name}
                  </option>
                ))}
              </select>
            </td>
            <td>
              <input
                type="date"
                className="form-control"
                name="task_start_date"
                value={formData.task_start_date}
                onChange={handleChange}
              />
            </td>
            <td>
              <input
                type="date"
                className="form-control"
                name="due_date"
                value={formData.due_date}
                onChange={handleChange}
              />
            </td>
          </tr>

          <tr className="tableHeading">
            <td>Task Category</td>
            <td>Task Title</td>
            <td>Task Description</td>
          </tr>
          <tr>
            <td>
              <select
                className="form-control"
                name="task_category"
                value={formData.task_category}
                onChange={handleChange}
              >
                <option value="">Select an option</option>
                <option value="Internal">Internal</option>
                <option value="Client-Related">Client-Related</option>
                <option value="Follow-up">Follow-up</option>
                <option value="Report / Documentation">
                  Report / Documentation
                </option>
                <option value="Review & Approval">Review & Approval</option>
                <option value="Data Entry">Data Entry</option>
                <option value="Development / Tech">Development / Tech</option>
                <option value="Audit / Compliance">Audit / Compliance</option>
              </select>
            </td>
            <td>
              <input
                className="form-control"
                type="text"
                name="task_title"
                value={formData.task_title}
                placeholder="Please Enter"
                onChange={handleChange}
              />
            </td>
            <td>
              <input
                className="form-control"
                type="text"
                name="task_description"
                value={formData.task_description}
                placeholder="Please Enter"
                onChange={handleChange}
              />
            </td>
          </tr>

          <tr className="space">
            <td colSpan={3}></td>
          </tr>

          <tr className="tableHeading">
            <td>Department</td>
            <td>Priority</td>
            <td>Task Source</td>
          </tr>
          <tr>
            <td>
              <select
                name="department"
                onChange={handleChange}
                className="dropdown-employee"
                value={formData.department}
              >
                <option value="">Select an option</option>
                {departmentDetailResponse.map((item) => (
                  <option value={item.dept_id}>{item.department}</option>
                ))}
              </select>
            </td>
            <td>
              <select
                className="form-control"
                name="task_priority"
                value={formData.task_priority}
                onChange={handleChange}
              >
                <option value="">Select an option</option>
                <option value="Critical">Critical</option>
                <option value="High">High</option>
                <option value="Medium">Medium</option>
                <option value="Low">Low</option>
              </select>
            </td>
            <td>
              <select
                className="form-control"
                name="task_source"
                value={formData.task_source}
                onChange={handleChange}
              >
                <option value="">Select an option</option>
                <option value="Internal Meeting">Internal Meeting</option>
                <option value="Client Request">Client Request</option>
                <option value="Email">Email</option>
                <option value="WhatsApp / Phone Call">
                  WhatsApp / Phone Call
                </option>
                <option value="Audit Observation">Audit Observation</option>
                <option value="SOP / Checklist">SOP / Checklist</option>
              </select>
            </td>
          </tr>

          <tr className="tableHeading">
            <td>Remarks</td>
          </tr>
          <tr>
            <td>
              <input
                className="form-control"
                type="text"
                name="remark"
                value={formData.remark}
                placeholder="Please Enter"
                onChange={handleChange}
              />
            </td>
          </tr>
        </tbody>
      </table>
      <br />

      <div className="reset-addLead-button">
        <button
          type="submit"
          style={{
            marginRight: "10px",
            backgroundColor: "#5B489D",
            color: "white",
          }}
          onClick={handleSubmit}
        >
          Assign Task
        </button>
      </div>

      <br />
    </div>
  );
};

export default AssignTask;
